import script from "./BaseBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseBadge.vue?vue&type=script&setup=true&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=258c7b72&lang=scss"

const __exports__ = script;

export default __exports__